module.exports = "https://cdn.hellotech.com/client-assets/phones_and_tablets_tablet_15cba7fb9ea5fcb52596b023b60ea4ab.png";